import { gridRowHeightInteger } from '@/list/list-constants';
import styled from 'styled-components';

export const IconWrapper = styled.div`
  height: ${gridRowHeightInteger}px;
  width: 100%;
  display: flex;
  align-items: center;

  > svg {
    width: ${(props) => `${props.width || 18}px`};
    height: ${(props) => (props.height ? `${props.height}px` : '18px')};
    cursor: pointer;
  }
`;
